import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Practice from "../components/Practice.vue";
import Free from "../components/Free.vue";
import Easy from "../components/Easy.vue";
import Hard from "../components/Hard.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/practice",
        name: "Practice",
        component: Practice,
    },
    {
        path: "/free",
        name: "Free",
        component: Free,
    },
    {
        path: "/easy",
        name: "Easy",
        component: Easy,
    },
    {
        path: "/hard",
        name: "Hard",
        component: Hard,
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
